import React from 'react';

import cx from 'classnames';

import s from './index.module.css';

function HeaderWrapper({ children, className }) {
  return (
    <div className={s.header}>
      <div className={cx(s.headerInner, className)}>{children}</div>
    </div>
  );
}

export default HeaderWrapper;
